import React from "react";
import Carousel from "react-elastic-carousel";

const PackageImageGallerySection = ({ packageDetails, resourceKeys }) => {
    const carouselItemStyle = {
        width: "770px", // Adjust as needed
        marginRight: "0px",
        float: "left",
        display: "block",
        hight: "300px",
    };

  const images = packageDetails?.BasicInfo?.PackageImageUrls || [];

  return (
    <div className="col-lg-8">
      <div className="flight_paxBlock pkg-dtls">
        <div className="airline_paxReview_tab common_bdrBtm">
          <div className="paxReview_journey_inside">
            <div className="row">
              <div className="gallery-col">
                <div className="hotel-gallery" style={{ display: "block" }}>
                  {images?.length > 0 ? (
                    <Carousel
                      itemsToShow={1}
                      className="slides"
                      pagination={false}
                      style={carouselItemStyle}
                    >
                      {images.map((image, index) => (
                        <div key={index} style={{ width: "100%" }}>
                          <img
                            src={image}
                            alt={`${resourceKeys?.Site_Name} ${packageDetails?.PackageName}`}
                            style={{ width: "100%", height: "300px", objectFit: "cover" }}
                            onError={(e) => {
                              e.target.onerror = null;
                            //   e.target.src = placeholderImage;
                            }}
                          />
                        </div>
                      ))}
                    </Carousel>
                  ) : (
                    <p>{resourceKeys?.no_images_available || "No images available"}</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PackageImageGallerySection;
